export default function Card(theme) {
  return {
    MuiCard: {
      defaultProps: {
        variant: theme.palette.mode === 'dark' ? 'outlined' : 'elevation',
      },
    },
  }
}
